<template>
    <div class="input-group" :class="{error: hasError}">
        <label v-if="label" :for="identifier">{{label}}</label>
        <textarea v-if="useTextarea" :id="identifier" :value="value" @input="(e)=>$emit('input', e.target.value)"
                  :placeholder="placeholder" :disabled="disabled" :autocomplete="autocomplete" :class="['input',{'large-textarea': largeTextarea}]"
                  :readonly="readonly"></textarea>
        <input v-else :id="identifier" :value="value" @input="(e)=>$emit('input', e.target.value)" :type="type"
               :placeholder="placeholder" :disabled="disabled" :autocomplete="autocomplete" class="input"
               :readonly="readonly" :class="{'primary-border': borderColor === 'primary'}">
        <FormErrors v-if="hasError">
            <slot name="errors"></slot>
        </FormErrors>
    </div>
</template>

<script>
    import FormErrors from "./FormErrors";

    export default {
        name: "FormInputText",
        components: {FormErrors},
        props: {
            value: {
                type: [String, Number],
            },
            identifier: {
                type: String,
                default: null,
            },
            type: {
                type: String,
                default: 'text'
            },
            label: {
                type: String,
                default: null,
            },
            placeholder: {
                type: String,
                default: null
            },
            autocomplete: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false
            },
            useTextarea: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            largeTextarea: {
                type: Boolean,
                default: false,
            },
            borderColor: {
                type: String,
                default: 'grey-light'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .input-group {
        @apply w-full flex flex-col items-start mb-5;

        label {
            @apply text-sm text-secondary font-bold mb-1;
        }

        .large-textarea {
            @apply h-9.5rem resize-none;
        }

        .input {
            @apply bg-white text-secondary text-sm font-normal border-2 border-grey rounded w-full py-3 px-4 appearance-none;

            &:focus {
                @apply border-primary outline-none;
            }

            &:disabled {
                @apply bg-grey-light;
                opacity: 0.5;
            }
        }

        .primary-border {
            @apply border-primary;
        }

        ::-webkit-input-placeholder { /* Edge */
            color: theme('colors.grey-dark') !important;
            opacity: 1 !important;
        }

        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: theme('colors.grey-dark') !important;
            opacity: 1 !important;
        }

        ::placeholder {
            color: theme('colors.grey-dark') !important;
            opacity: 1 !important;
        }

        &.error {
            .input {
                @apply border-negative;
            }
        }
    }
</style>